import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, IconButton, Button } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/Logo.png";
import "./Navbar.css";
import "./Navbar1.css";
import { isLoggedIn, getRole } from "../Utility/helper";
import NavLinks from "./NavLinks";
import MobileDrawer from "./MobileDrawer";

const Navbar = () => {
  const location = useLocation();
  const [mobileView, setMobileView] = useState(window.innerWidth <= 768);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const loggedIn = isLoggedIn();
  const role = getRole();
  const dashboardPath = ["super_admin", "manager"].includes(role)
    ? "/Super-Dash"
    : "/dashboard";

  useEffect(() => {
    const handleResize = () => setMobileView(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleDrawer = (open) => () => setDrawerOpen(open);
  const isActive = (path) => location.pathname === path;
  const handleLogout = () => {
    sessionStorage.clear();
    window.location.href = "/";
  };

  return (
    <AppBar position="static" className="navbar">
      <Toolbar disableGutters className="toolbar-content">
        {mobileView ? (
          <div className="mobile-navbar-wrapper">
            {/* Left: Menu Icon + Logo */}
            <div className="mobile-left">
              <IconButton
                edge="start"
                color="inherit"
                onClick={toggleDrawer(true)}
                className="menu-icon"
                sx={{
                  padding: 0,
                  margin: 0,
                  minWidth: 0,
                  height: "36px",
                  width: "36px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <MenuIcon sx={{ fontSize: 24 }} />
              </IconButton>

              <Link to="/" className="navbar-logo">
                <img src={logo} alt="Logo" className="logo-img" />
              </Link>
            </div>

            {/* Right: Login/Logout */}
            <div className="mobile-right">
              {loggedIn ? (
                <Button
                  variant="contained"
                  className="login-button"
                  onClick={handleLogout}
                  sx={{
                    height: "36px",
                    padding: "0 12px",
                    fontSize: "0.75rem",
                    fontWeight: "bold",
                    backgroundColor: "#D4A373",
                    color: "#000",
                    borderRadius: "6px",
                    textTransform: "none",
                    whiteSpace: "nowrap",
                    lineHeight: "36px",
                    display: "inline-block",
                    verticalAlign: "middle",
                    margin: 0,
                  }}
                >
                  Logout
                </Button>
              ) : (
                <Button
                  component={Link}
                  to="/login"
                  variant="contained"
                  className="login-button"
                  sx={{
                    height: "36px",
                    padding: "0 12px",
                    fontSize: "0.75rem",
                    fontWeight: "bold",
                    backgroundColor: "#D4A373",
                    color: "#000",
                    borderRadius: "6px",
                    textTransform: "none",
                    whiteSpace: "nowrap",
                    lineHeight: "36px",
                    display: "inline-block",
                    verticalAlign: "middle",
                    margin: 0,
                  }}
                >
                  Login
                </Button>
              )}
            </div>
          </div>
        ) : (
          <>
            <Link to="/" className="navbar-logo">
              <img src={logo} alt="Logo" className="logo-img" />
            </Link>
            <div className="navbar-right-section">
              <ul className="navbar-links">
                <NavLinks
                  loggedIn={loggedIn}
                  role={role}
                  isActive={isActive}
                  dashboardPath={dashboardPath}
                />
              </ul>
              {loggedIn ? (
                <Button
  variant="contained"
  onClick={handleLogout}
  sx={{
    backgroundColor: '#D4A373',
    color: '#000',
    fontWeight: 'bolder',
    textTransform: 'none',
    borderRadius: '6px',
    padding: '8px 15px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    fontSize: '1rem',
    lineHeight: 1.5,
    '&:hover': {
      backgroundColor: '#c68f4f',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
    },
    '&:focus': {
      outline: '2px solid #c68f4f',
      outlineOffset: '2px',
    },
  }}
>
  Logout
</Button>
              ) : (
                <Button
                  component={Link}
                  to="/login"
                  variant="contained"
                  className="login-button"
                >
                  Login
                </Button>
              )}
            </div>
          </>
        )}
      </Toolbar>

      <MobileDrawer
        open={drawerOpen}
        toggleDrawer={toggleDrawer}
        loggedIn={loggedIn}
        role={role}
        dashboardPath={dashboardPath}
        handleLogout={handleLogout}
      />
    </AppBar>
  );
};

export default Navbar;